import { Outlet } from 'react-router-dom'
import Header from '../Header/Header'
import Sidebar from '../Sidebar/Sidebar'
import Footer from '../Footer/Footer'
import './PortalLayout.scss'

export const PortalLayout = () => {
  return (
    <div className="crif-portal-layout">
      <Header />

      <div className="crif-portal-body">
        <Sidebar />

        <main className="crif-portal-main">
          <Outlet />
        </main>
      </div>

      <Footer />
    </div>
  )
}

export default PortalLayout
